<!-- =========================================================================================
  File Name: DailyWatch.vue.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-col  w-full mb-base">
    <vx-card>

      <vs-row  class="vx-col  w-full mb-base">
        <label class="mt-2"> &nbsp;From: &nbsp;</label>
        <flat-pickr placeholder="From Date"  :config="configTodateTimePicker" v-model="fromDate" format="MM/dd/yyyy"/>
        <label class="mt-2"> &nbsp;To: &nbsp;</label>
        <flat-pickr class="ml-1 from-control" :config="configTodateTimePicker" v-model="toDate" placeholder="To Date"
                    format="Y-m-d\\Z"/>

        <vs-button @click.native="getWatchTimeReportByDate()" color="primary" class="ml-1 flex inline-flex" type="border"
                   icon-pack="feather" icon="icon-search"></vs-button>
          <label class="mt-2">  &nbsp;  &nbsp;Filter By Camera: &nbsp;</label>
          <v-select label="name" :clearable="false" :closeOnSelect="true" v-model="CameraId" :options="CamerasList"
                    @input="SearchByCamera"  style="width:150px"/>
          <br>
      </vs-row>


      <vue-apex-charts type="bar" :height=" 50 * userNames.length+45 " :options="getUsersName"
                       :series="getwatchTime"></vue-apex-charts>
    </vx-card>
    <br>
    <div class="vx-col  w-full mb-base">
      <vx-card title="Last Week at a Glance">
        <vue-apex-charts type="area" height="300" :options="weeklyWatchTimeData.chartOptions"
                         :series="weeklyWatchTimeData.series"></vue-apex-charts>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import vSelect from 'vue-select'
import {colors} from '../../../themeConfig'

import {
  GET_REPORT_CAMERAS_LIST,
  WATCH_TIME_MONTHLY_REPORT,
  WATCH_TIME_REPORT,
  WATCH_TIME_REPORT_BY_CAMERA,
  WATCH_TIME_REPORT_BY_DATE,
  CAMERAS_BY_MANAGER_LOCATION
} from '@/graphql'

export default {
  components: {
    VueApexCharts,
    Datepicker,
    flatPickr,
    moment,
    'v-select': vSelect
  },
  data () {
    return {
      options: ['one', 'two', 'three'],
      userNames: [],
      userWatchTime: [],
      fromDate: '',
      toDate: '',
      DaysData: [],
      WatchTimeData: [],
      CamerasList: [],
      CameraId:{'id':'All', 'name':'All'},
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null,
        dateFormat: 'm/d/Y'
      },
      role:null

    }
  },
  computed: {
    getUsersName () {
      return {
        colors: colors.primary,
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter (value) {
              return `${value  } Minutes`
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.userNames,
          labels: {
            show: false
          }
        }
      }
    },
    getwatchTime () {
      return [{name: 'Watch Time', data: this.userWatchTime}]
    },
    weeklyWatchTimeData () {
      return {
        colors: [colors.primary],
        series: [
          {
            name: 'Watch Time ',
            data: this.WatchTimeData
          }
        ],
        chartOptions: {
          dataLabels: {
            enabled: false
          },
          chart: {
            sparkline: {
              enabled: true
            }
          },
          stroke: {
            curve: 'smooth',
            colors: colors.primary
          },
          fill: {
            type: 'solid',
            colors: colors.primary,
            opacity: [1]
          },
          tooltip: {
            enabled: true,
            y: {
              formatter (value) {
                return `${value  } Minutes`
              }
            }
          },
          xaxis: {

            categories: this.DaysData
          },
          yaxis: {
            labels: {
              show: false
            }
          }
        }
      }

    }
  },
  methods: {

    watchTimeMonthlyReport () {
      this.$apollo
        .query({
          query: WATCH_TIME_MONTHLY_REPORT
        }).then(response => {
          const totalTimeData = []
          const usersData = []
          if (response) {
            if (response.data.watchTimeMonthlyReport.data.length == 0) {

              totalTimeData.push(0)
              usersData.push('No data found.')
              this.userWatchTime = totalTimeData
              this.userNames = usersData
            } else {
              for (let i = 0; i < response.data.watchTimeMonthlyReport.data.length; i++) {
                totalTimeData.push(response.data.watchTimeMonthlyReport.data[i].minutes)
                usersData.push(`${response.data.watchTimeMonthlyReport.data[i].user.fname  } ${  response.data.watchTimeMonthlyReport.data[i].user.lname}`)
              }
              this.userWatchTime = totalTimeData
              this.userNames = usersData
              // this.getCamerasList()
            }

          }

        })
        .catch(error => {
        })
    },
    getWatchTimeReportByDate () {
      this.$apollo
        .query({
          query: WATCH_TIME_REPORT_BY_DATE,
          variables: {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
        }).then(response => {
          if (response) {
            const totalTimeData = []
            const usersData = []

            if (response.data.watchTimeReportByDate.data.length == 0) {
              totalTimeData.push(0)
              usersData.push('No data found.')
              this.userWatchTime = totalTimeData
              this.userNames = usersData
            } else {
              for (let i = 0; i < response.data.watchTimeReportByDate.data.length; i++) {
                totalTimeData.push(response.data.watchTimeReportByDate.data[i].minutes)
                usersData.push(`${response.data.watchTimeReportByDate.data[i].user.fname  } ${  response.data.watchTimeReportByDate.data[i].user.lname}`)

              }
            }
            this.userWatchTime = totalTimeData
            this.userNames = usersData

          }
        })
        .catch(error => {
        })

    },
    SearchByCamera () {
      if (this.CameraId.id === 'All') {
        this.watchTimeMonthlyReport()
      } else {
      //refresh the selected dates again after submit data
        this.toDate = this.toDate
        this.fromDate = this.fromDate

        this.$apollo
          .query({
            query: WATCH_TIME_REPORT_BY_CAMERA,
            variables: {
              fromDate: this.fromDate,
              toDate: this.toDate,
              camera_id: this.CameraId.id
            }
          }).then(response => {
            if (response) {
              const totalTimeData = []
              const usersData = []

              if (response.data.watchTimeReportByCamera.data.length == 0) {
                totalTimeData.push(0)
                usersData.push('No data found.')
                this.userWatchTime = totalTimeData
                this.userNames = usersData
              } else {
                for (let i = 0; i < response.data.watchTimeReportByCamera.data.length; i++) {
                  totalTimeData.push(response.data.watchTimeReportByCamera.data[i].minutes)
                  usersData.push(`${response.data.watchTimeReportByCamera.data[i].user.fname  } ${  response.data.watchTimeReportByCamera.data[i].user.lname}`)

                }
              }
              this.userWatchTime = totalTimeData
              this.userNames = usersData

            }
          })
          .catch(error => {
          })
      }
    },
    watchTimeWeeklyReport () {
      const today = new Date().toISOString().slice(0, 10)
      this.$apollo
        .mutate({
          mutation: WATCH_TIME_REPORT,
          variables: {
            date: today
          }
        }).then(response => {
          this.DaysData = response.data.watchTimeWeeklyReport.data.lables
          this.WatchTimeData = response.data.watchTimeWeeklyReport.data.values

        }).catch(error => {
        })
    },
    getCamerasList () {
      if(this.role==='manager'){
      let id = localStorage.getItem('userId');
       this.$apollo
          .mutate({
            mutation: CAMERAS_BY_MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            const cameras = []
            cameras.unshift({'id':'All', 'name':'All'})
            for (let i = 0; i < response.data.user.managerlocations.length; i++) {
              for (let j = 0; j < response.data.user.managerlocations[i].cameras.length; j++) {
                cameras.push(response.data.user.managerlocations[i].cameras[j])
              }
            }
            this.CamerasList = cameras
          }).catch(error => {
            console.log(error)
          })
      }
      else{
        this.$apollo
        .query({
          query: GET_REPORT_CAMERAS_LIST
        })
        .then(response => {
          response.data.cameras.unshift({'id':'All', 'name':'All'})
          this.CamerasList = response.data.cameras

        })
      }
      
    }

  },
  created () {
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
    this.watchTimeMonthlyReport()
    this.watchTimeWeeklyReport()
    this.getCamerasList()

    const today = new Date()
    const setcurrentDayDate = today.toISOString()

    const setLastMonthDate = today.setDate(today.getDate() - 30)
    const lastMonthDate = new Date(setLastMonthDate).toISOString()

    this.toDate = setcurrentDayDate
    this.fromDate = lastMonthDate


  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
